import { COUNTRY_ISO } from '@/constants/countries';

const DELIVERY_TYPES = {
  CLASSIC: 'classic',
  EXPRESS: 'express',
  FIXED: 'fixedDelivery'
};

const BILLING_ADDRESS_TYPES = {
  SHIPPING: 'shipping',
  DIFFERENT: 'different'
};

const ERROR_MESSAGES = {
  REQUIRED: 'common.input.requiredFieldMessage',
  INCORRECT_ZIP_CODE: 'checkout.input.zipcodeValidationErrorMessage',
  LATIN_CHARACTERS_ERROR: 'checkout.input.latinLettersValidationErrorMessage',
  REQUIRED_MIN_LENGTH: 'min RFC length is 12 characters',
  VALID_PHONE_NUMBER: 'Should be a valid phone number',
  DIGITS_ONLY: 'Should contain only digits'
};

export const ADDRESS_FIELD = {
  /* Common */
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  CITY: 'city',
  ZIP_CODE: 'zipCode',
  PHONE: 'phone',
  PHONE_ISO: 'phoneIso',
  COUNTRY_CODE: 'countryCode',
  APARTMENT: 'apartment',

  /* All but Saudi Arabia */
  ADDRESS: 'address',

  /* Countries with states */
  STATE_CODE: 'stateCode',

  /* Saudi Arabia */
  DISTRICT: 'district',
  STREET: 'street',
  BUILDING: 'building',

  /* Mexico */
  RFC: 'rfc',
  REFERENCE: 'reference',
  CFDI_ID: 'cfdiId'
};

const getDefaultStateCode = countryCode => {
  if (countryCode.toUpperCase() === COUNTRY_ISO.UNITED_STATES) {
    return 'CA';
  }

  return '';
};

const DEFAULT_ADDRESS_FIELDS = Object.values(ADDRESS_FIELD).reduce((acc, fieldName) => {
  if (fieldName === ADDRESS_FIELD.CFDI_ID) {
    acc[fieldName] = null;

    return acc;
  }

  acc[fieldName] = '';

  return acc;
}, {});

export const ADDRESS_TYPE = {
  SHIPPING: 'SHIPPING',
  BILLING: 'BILLING'
};

const ADDRESS_FIELD_NAMES = {
  APARTMENT: 'apartment',
  ZIP_CODE: 'zipCode',
  STATE_CODE: 'stateCode',
  REFERENCE: 'reference',
  RFC: 'rfc',
  CFDI_ID: 'cfdiId'
};

const EXTENDED_LATIN_CHARACTERS_REGEXP = /^[\u0020-\u008F,\u00A1-\u017F]+$/;

export {
  DELIVERY_TYPES,
  BILLING_ADDRESS_TYPES,
  ERROR_MESSAGES,
  ADDRESS_FIELD_NAMES,
  EXTENDED_LATIN_CHARACTERS_REGEXP,
  DEFAULT_ADDRESS_FIELDS,
  getDefaultStateCode
};
